import Image from 'next/image';

import { getAbsoluteMediaUrl } from '@umbraco/Utils/GetAbsoluteMediaUrl';

type MediaImageProps = {
  image: { url: string; name: string };
  alt: string;
  sizes?: string;
  objectFit?: 'contain' | 'cover';
  className?: string;
  loading?: 'lazy' | 'eager';
  priority?: boolean;
};

export const MediaImage = ({
  image,
  alt,
  sizes,
  objectFit,
  className,
  loading,
  priority,
}: MediaImageProps) => (
  <Image
    src={getAbsoluteMediaUrl(image.url)}
    alt={alt}
    fill
    sizes={sizes}
    className={className}
    style={objectFit ? { objectFit } : undefined}
    loading={loading}
    priority={priority}
  />
);
